import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PersonalService } from '../../../../core/services/personal.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { PersonalListComponent } from '../../../components/personal-list/personal-list.component';

@Component({
    selector: 'app-professor-personal-list',
    templateUrl: './professor-personal-list.component.html',
    imports: [
        PersonalListComponent,
        CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule
    ],
    styleUrls: ['./professor-personal-list.component.css']
})
export class ProfessorPersonalListComponent {
  vue="list"
  datas:any[]=[]
  tag="professors-classroom-professors-list"

  constructor(
    private personalService:PersonalService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }

     ngOnInit(): void {
      this.getPersonals()
    }


  changeView(event:any){
    this.vue=event.target.value
  }

  getPersonals(){
    this.personalService.getAll().subscribe((res:any)=>{
      this.datas=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Consultation du personnel",err)
    })
  }

  
}
